import { useTranslation } from 'react-i18next';

import ReportsAccordion from '../General/ReportsAccordion';

import TrapsDataElement from './TrapsDataElement';

import { TrapData } from 'api/periodReports/type';

const TrapsDataAccordion: React.FC<{ trap_data_list: TrapData[] }> = ({ trap_data_list }) => {
  const { t } = useTranslation();
  return (
    <ReportsAccordion
      title={t('TrapsDataList.accordion.accordion-title')}
      noDataText={t('TrapsDataList.accordion.accordion-inner.no-data')}
      key={t('TrapsDataList.accordion.accordion-title')}
      data={trap_data_list}
      mapElement={(data: TrapData) => <TrapsDataElement data={data} />}
    />
  );
};

export default TrapsDataAccordion;
